/* eslint-disable no-mixed-spaces-and-tabs */
const colorRequestConfirmationMessage = ".confirmation-message",
	colorRequestConfirmationMessageClose = ".details__color-request__form .confirmation-message-close",
	colorRequestWrapper = ".details__color-request",
	colorRequestGFormWrapper = ".details__color-request__form .gform_wrapper",
	colorRequestFormWrapper = ".details__color-request__form__wrapper",
	colorRequestButton = ".download-button--colors",
	colorRequestInputSelect = ".select-item--color input[type=checkbox]";

/**
 * Gallery and Modal Constants
 */
const modalThumbnail = document.querySelectorAll(".modal__gallery__thumbnail");
const modalMainImage = document.querySelector(".modal__gallery__mainimage");
const modalOpeners = document.querySelectorAll("[data-open]");
const thumbnailImageSourceReplace = "-150x150";
const thumbnailActiveClass = "thumbnail--active";
const thumbnailVideoClass = "thumbnail--video";
const mainImageVideoClass = "mainimage--video";
let thumbSrc;

/**
 * Toogle Form
 */
function toogleForm(status) {
	const form = jQuery(colorRequestFormWrapper);
	if (status) {
		form.slideDown();
	} else {
		form.slideUp();
	}
}
/**
 * Product Download Button
 */
window.productDownloadButton = function (selectItem, buttonClass) {
	const downloadFileCheckboxes = document.querySelectorAll(selectItem);
	const downloadButton = document.querySelector(buttonClass);
	if (downloadButton) {
		const downloadButtonTextWrap = downloadButton.querySelector("span");
		const downloadButtonText = downloadButtonTextWrap.textContent;
		// const colorRequestWrapperE = jQuery(colorRequestWrapper)
		let filesToDownload = [];
		let colorSamplesToRequest = [];

		downloadFileCheckboxes.forEach((checkbox) => {
			checkbox.addEventListener("change", () => {
				filesToDownload = Array.from(downloadFileCheckboxes).filter((i) => i.checked);

				if (filesToDownload.length) {
					//If we have files selected

					if (downloadButton instanceof HTMLAnchorElement) {
						// prepare download files href
						downloadButton.classList.remove("disabled");
						downloadButton.href = "/wp-json/d6/v1/downloads/" + filesToDownload.map((i) => i.dataset.id).join(",");
					} else if (downloadButton instanceof HTMLButtonElement) {
						//Color Sample Request
						//Set Selecoted Colors hidden field.
						colorSamplesToRequest =
							"<table><thead><td>Color</><td>SKU</td>" +
							filesToDownload
								.map((i) => "<tr><td>" + i.dataset.name + "</td><td>" + i.dataset.sku + "</td></tr>")
								.join("") +
							"</table>";
						const hiddenField = document.querySelector('input[name="input_6"][type="hidden"]');
						if (hiddenField) hiddenField.value = colorSamplesToRequest;

						//Enable download button
						// colorRequestWrapperE.attr('style', 'display: flex !important')
						// colorRequestWrapperE.slideDown(() => {
						//   colorRequestWrapperE.attr('style', 'display: flex !important')
						// })
						downloadButton.disabled = false;

						//if form confirmation message is showing show form
						let confirmationMessage = document.querySelector(colorRequestConfirmationMessage);
						if (confirmationMessage) {
							downloadButton.classList.add("open");
							toogleForm(true);
						}
						//Show inner form(could be hidden after first submission)
						const formWrapper = jQuery(colorRequestGFormWrapper);
						if (formWrapper) formWrapper.slideDown();
					}

					//update button text
					if (filesToDownload.length >= 2) {
						downloadButtonTextWrap.innerText = downloadButtonText + "s";
					} else {
						downloadButtonTextWrap.innerText = downloadButtonText;
					}
				} else {
					//No files selected
					if (downloadButton instanceof HTMLAnchorElement) {
						// Disabled Files Download
						downloadButton.href = "#";
						downloadButton.classList.add("disabled");
					} else if (downloadButton instanceof HTMLButtonElement) {
						//Disabled Color Sample Button and form
						downloadButton.disabled = true;
						const formWrapper = jQuery(colorRequestGFormWrapper);
						if (formWrapper) formWrapper.slideUp();

						if (!document.querySelector(colorRequestConfirmationMessage)) {
							downloadButton.classList.remove("open");
							toogleForm(false);
							// colorRequestWrapperE.slideUp()
						}
					}
				}
			});
		});

		//Request Sample Button Click bind toggles form vibility
		downloadButton.addEventListener("click", function (e) {
			if (e.currentTarget instanceof HTMLButtonElement) {
				if (!e.currentTarget.classList.contains("open")) {
					e.currentTarget.classList.add("open");
					toogleForm(true);
				} else {
					e.currentTarget.classList.remove("open");
					toogleForm(false);
				}
			}
		});
	}
};

if (document.querySelector(colorRequestInputSelect)) {
	productDownloadButton(colorRequestInputSelect, colorRequestButton);
}
if (document.querySelector(".select-item--plan input[type=checkbox]")) {
	productDownloadButton(".select-item--plan input[type=checkbox]", ".download-button--plans");
}

productDownloadButton(".tab-content__ti__downloads__download input[type=checkbox]", ".download-button--plans");

/**
 * Color Samples Request Form Confirmation Close Click Callback
 */

function colorRequestConfirmationClose() {
	document.querySelector(colorRequestConfirmationMessage).remove();
	const colorRequestWrapperE = jQuery(colorRequestWrapper);
	const selectedCheckboxes = Array.from(document.querySelectorAll(colorRequestInputSelect)).filter((i) => i.checked);
	if (selectedCheckboxes.length == 0) {
		document.querySelector(colorRequestButton).classList.remove("open");
		toogleForm(false);
		colorRequestWrapperE.slideUp();
	}
}

/**
 * jQuery was used as the GravityForm gform_confirmation_loaded event is triggered using jQuery trigger() and can only be catched with on()
 */
/*globals jQuery:false */
jQuery(document).ready(function () {
	const confMessageClose = document.querySelector(colorRequestConfirmationMessageClose);
	if (confMessageClose) confMessageClose.addEventListener("click", colorRequestConfirmationClose);
	toogleForm(false);
	jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
		if (document.querySelector("#confirmation-message_" + formId)) {
			// Only when the event is comming from the Request Color Sample Form
			const selectedCheckboxes = Array.from(
				document.querySelectorAll(".select-item--color input[type=checkbox]"),
			).filter((i) => i.checked);
			for (let i = 0; i < selectedCheckboxes.length; i++) {
				selectedCheckboxes[i].checked = false;
				selectedCheckboxes[i].dispatchEvent(new Event("change"));
			}
			document.querySelector(".download-button--colors").classList.remove("open");
			const form_inner_wrapper = document.querySelector(colorRequestGFormWrapper);
			form_inner_wrapper.style.display = "none";
			document
				.querySelector(colorRequestConfirmationMessageClose)
				.addEventListener("click", colorRequestConfirmationClose);
		}
	});
});

/**
 * Gallery and Modal Constants
 */
// const modalThumbnail = document.querySelectorAll('.modal__gallery__thumbnail');
// const modalMainImage = document.querySelector('.modal__gallery__mainimage');
// const modalOpeners = document.querySelectorAll('[data-open]');
// const thumbnailImageSourceReplace = '-150x150';
// const thumbnailActiveClass = 'thumbnail--active';
// const thumbnailVideoClass = 'thumbnail--video';
// const mainImageVideoClass = 'mainimage--video';
// let thumbSrc;
/**
 * Gallery
 */
// function galleryImageSwap(handler, thumbnailsClass, mainImageClass) {
//   const thumbnails = document.querySelectorAll(thumbnailsClass)
//   const mainImageWrap = document.querySelector(mainImageClass)
// 	const mainImage = document.querySelector(mainImageClass + ' img')
// 	const previewImage = document.querySelector('.color-preview')
//   thumbnails.forEach(thumb => {
//     thumb.addEventListener(handler, () => {
//       Array.from(document.querySelectorAll(thumbnailsClass + '.' + thumbnailActiveClass)).forEach(
//         (activeThumb) => activeThumb.classList.remove(thumbnailActiveClass)
// 			)

// 			// if(thumbnailsClass === '.details__color__image'){
// 			// 	mainImageWrap.classList.add('color-active');
// 			// } else {
// 			// 	mainImageWrap.classList.remove('color-active');
// 			// }
// 			mainImageWrap.classList.remove('color-active');
//       thumb.classList.add(thumbnailActiveClass)

//       thumbSrc = thumb.querySelector('img').src.replace(thumbnailImageSourceReplace, '')
// 			mainImage.src = thumbSrc

// 			// change preview image
//       previewImage.src = thumbSrc

//       if (mainImageWrap.hasAttribute('data-open')) {
//         modalOpeners.forEach(opener => {
//           opener.setAttribute('data-goto', thumb.id)
//         })
//       }

//       if (thumb.classList.contains(thumbnailVideoClass)) {
//         mainImageWrap.classList.add(mainImageVideoClass)
//         if (thumb.classList.contains('gallery__thumbnail')) {
//           mainImageWrap.setAttribute('data-open', 'video-' + thumb.getAttribute('data-video'))
//         }
//       } else {
//         mainImageWrap.classList.remove(mainImageVideoClass)
//         mainImageWrap.setAttribute('data-open', 'modal-gallery')
//       }
// 			// document.getElementById('mainImage-large').setAttribute('src', thumbSrc)

//     })
//   })

// }

// galleryImageSwap('mouseenter', '.gallery__thumbnail', '.gallery__mainimage')
// // galleryImageSwap('mouseenter', '.details__color__image', '.gallery__mainimage')
// galleryImageSwap('click', '.modal__gallery__thumbnail', '.modal__gallery__mainimage')

/**
 * Go to matching thumbnail in modal
 */
function modalJumpTo() {
	modalOpeners.forEach((modalOpen) => {
		modalOpen.addEventListener("click", function () {
			const jumpToNumber = this.getAttribute("data-goto");

			if (jumpToNumber.includes("modal")) {
				document.getElementById(jumpToNumber).click();
			} else {
				document.getElementById("modal__" + jumpToNumber).click();
			}
		});
	});
}

/**
 * Create video iframe in modal
 *
 */
// TODO: Wire this up to Youtube API
function modalCreateVideo() {
	modalThumbnail.forEach((thumb) => {
		thumb.addEventListener("click", function () {
			if (thumb.classList.contains(thumbnailVideoClass)) {
				const url = new URL(thumb.querySelector("img").src);

				const videoId = url.searchParams.get("vid");

				const iframe = document.createElement("iframe");
				iframe.width = "100%";
				iframe.height = "100%";
				iframe.id = videoId;
				iframe.setAttribute(
					"src",
					"https://www.youtube.com/embed/" +
						videoId +
						"?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0",
				);

				if (document.getElementById(videoId) === null) {
					modalMainImage.querySelectorAll("iframe").forEach((iframe) => iframe.remove());
					modalMainImage.appendChild(iframe);
				}
			}
		});
	});
}

function modalRemoveIframe(element) {
	document.querySelectorAll(element).forEach((el) => {
		el.addEventListener("click", function () {
			if (modalMainImage.querySelector("iframe") !== null) {
				modalMainImage.querySelectorAll("iframe").forEach((iframe) => iframe.remove());
			}
		});
	});
}

modalJumpTo();

modalCreateVideo();

modalRemoveIframe(".modal__close, .modal__gallery__thumbnail:not(.thumbnail--video)");

/**
 * Product Title Slider
 */
// function productSectionTitleSlider(handler, productSectionTitleClass) {
//   const productSectionTitle = document.querySelectorAll(productSectionTitleClass)

//   productSectionTitle.forEach(title => {
//     title.addEventListener(handler, () => {
//       if (title.classList.contains('active')) {
//         title.classList.remove('active')
//       } else {
//         Array.from(document.querySelectorAll(productSectionTitleClass)).forEach(
//           (activeTitle) => activeTitle.classList.remove('active')
//         )
//         title.classList.add('active')
//       }
//     })
//   })
// }

// productSectionTitleSlider('click', '.details__section__title')

const detailSectionPlansToggle = document.querySelectorAll(".details__section--plans__more--toggle");
const detailSectionPlansContent = document.querySelectorAll(".details__section--plans__more--content");

function technicalInfoOnLoad() {
	const mql = window.matchMedia("(min-width: 64em)");
	if (mql.matches) {
		// the width of browser is more than 64em
		jQuery(detailSectionPlansContent).hide();
	}

	window.addEventListener("resize", () => {
		const mql = window.matchMedia("(min-width: 64em)");
		jQuery(detailSectionPlansContent).toggle(!mql.matches);
		jQuery(detailSectionPlansToggle).toggleClass("open", !mql.matches);
	});

	Array.from(detailSectionPlansToggle).forEach((sectionPlan) => {
		sectionPlan.addEventListener("click", (e) => {
			if (!e.currentTarget.classList.contains("open")) {
				e.currentTarget.classList.add("open");
				let content = e.currentTarget.previousElementSibling;
				jQuery(content).slideDown(400, () => {
					content.style.display = "flex";
				});
			} else {
				e.currentTarget.classList.remove("open");
				jQuery(e.currentTarget.previousElementSibling).slideUp();
				//e.currentTarget.previousElementSibling.style.display = 'none';
			}
		});
	});
}
technicalInfoOnLoad();

jQuery(function ($) {
	jQuery(".zoom").zoom({
		target: jQuery(".zoom"),
	});

	jQuery(document).on("click", ".details__color", function () {
		if (jQuery(this).find(".select-item__checkbox").is(":checked")) {
			jQuery(this).addClass("active");
		} else {
			jQuery(this).removeClass("active");
		}

		if (jQuery(".details__color.active").length == 0) {
			let previousActiveImg = jQuery(".gallery__thumbnails .gallery__thumbnail.thumbnail--active");
			let previousActiveImgIndex = jQuery(".gallery__thumbnails .gallery__thumbnail.thumbnail--active").attr("id");

			// defaults to first image if clicked see more
			if (previousActiveImg.data("open")) {
				previousActiveImgIndex = 0;
			} else {
				previousActiveImgIndex = jQuery(".gallery__thumbnails .gallery__thumbnail.thumbnail--active").attr("id");
			}

			jQuery(".gallery__thumbnails #" + previousActiveImgIndex + ".gallery__thumbnail").trigger("click");
		} else {
			var imgSrc = jQuery(this).find("img").attr("src");
			var imgSrcUpdated = imgSrc.replace("-150x150", "");
			jQuery(".gallery__mainimage img, .gallery__mainimage .color-preview").attr("src", imgSrcUpdated);
			jQuery(".gallery__mainimage").addClass("color-active");
			$(".zoom").trigger("zoom.destroy");
		}
	});

	function galleryImageSwap(handler, thumbnailsClass, mainImageClass) {
		const thumbnails = document.querySelectorAll(thumbnailsClass);
		const mainImageWrap = document.querySelector(mainImageClass);
		const mainImage = document.querySelector(mainImageClass + " img");
		const previewImage = document.querySelector(".color-preview");
		thumbnails.forEach((thumb) => {
			thumb.addEventListener(handler, () => {
				Array.from(document.querySelectorAll(thumbnailsClass + "." + thumbnailActiveClass)).forEach((activeThumb) =>
					activeThumb.classList.remove(thumbnailActiveClass),
				);
				// if(thumbnailsClass === '.details__color__image'){
				// 	mainImageWrap.classList.add('color-active');
				// } else {
				// 	mainImageWrap.classList.remove('color-active');
				// }
				mainImageWrap.classList.remove("color-active");
				thumb.classList.add(thumbnailActiveClass);

				thumbSrc = thumb.querySelector("img").src.replace(thumbnailImageSourceReplace, "");
				mainImage.src = thumbSrc;

				// change preview image
				previewImage.src = thumbSrc;
				// console.log(thumbSrc);

				$(".zoom").zoom({
					url: thumbSrc,
				});

				if (mainImageWrap.hasAttribute("data-open")) {
					modalOpeners.forEach((opener) => {
						opener.setAttribute("data-goto", thumb.id);
					});
				}

				if (thumb.classList.contains(thumbnailVideoClass)) {
					mainImageWrap.classList.add(mainImageVideoClass);
					if (thumb.classList.contains("gallery__thumbnail")) {
						mainImageWrap.setAttribute("data-open", "video-" + thumb.getAttribute("data-video"));
						// $('.zoom').trigger('zoom.destroy');
					}
				} else {
					mainImageWrap.classList.remove(mainImageVideoClass);
					mainImageWrap.setAttribute("data-open", "modal-gallery");
				}

				// remove zoom if 'see more'
				if (thumb.classList.contains("see-more")) {
					if (thumb.classList.contains("gallery__thumbnail")) {
						// $('.zoom').trigger('zoom.destroy');
					}
				}
				// document.getElementById('mainImage-large').setAttribute('src', thumbSrc)
			});
		});
	}
	galleryImageSwap("click", ".gallery__thumbnail", ".gallery__mainimage");
	// galleryImageSwap('mouseenter', '.details__color__image', '.gallery__mainimage')
	galleryImageSwap("click", ".modal__gallery__thumbnail", ".modal__gallery__mainimage");
});
